import React from 'react';
import Radium from 'radium';
import Theme from '../../styles/theme';
import StyleDecorator from '../StyleDecorator';
import AttentionIcon from '../images/AttentionIcon';

class ErrorMessage extends React.Component {
	static propTypes = {
		text: React.PropTypes.string.isRequired,
	};

	getStyle() {
		return {
			container: {
				padding: '20px',
				color: Theme.palette.primary2Color,
				backgroundColor: Theme.palette.errorColor,
				display: 'flex',
				alignItems: 'center',
			},
			icon: {
				marginRight: '13px',
				padding: '5px',
				color: Theme.palette.primary2Color,
				height: '32px',
				width: '32px',
			},
			message: {
				fontWeight: '100',
				textAlign: 'left',
				color: 'white',
				lineHeight: '1.2em',
			},
		};
	}

	render() {
		const style = this.getStyle();

		return (
			<div
				key={'error-message'}
				style={style.container}
			>
				<AttentionIcon
					color={Theme.palette.primary2Color}
					exclamationMarkColor={Theme.palette.errorColor}
					style={style.icon}
				/>
				<span style={style.message}>{this.props.text}</span>
			</div>
		);
	}
}

export default StyleDecorator(Radium(ErrorMessage));



// WEBPACK FOOTER //
// ./src/components/messages/ErrorMessage.js